<template>
  <div>
    <list
      row-key="GoodsId"
      ref="list"
      unit="往来单位"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="true"
      :get-data-func="api.list2"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单位类型">
          <el-select size="mini" v-model="params.TradeUnitType" placeholder="请选择单位类型" clearable>
            <el-option label="客户" :value="1" v-if="v1"></el-option>
            <el-option label="供应商" :value="2" v-if="v2"></el-option>
            <el-option label="往来" :value="3" v-if="v3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位编码">
          <el-input size="mini" clearable v-model="params.TradeUnitCode" placeholder="请输入单位名称" />
        </el-form-item>
        <el-form-item label="单位名称">
          <el-input size="mini" clearable v-model="params.TradeUnitName" placeholder="请输入单位名称" />
        </el-form-item>
        <!-- <el-form-item label="商品名称">
          <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input size="mini" clearable v-model="params.Model" placeholder="请输入规格型号" />
        </el-form-item>
        <el-form-item label="商品标签">
          <el-input size="mini" v-model="params.Tags" placeholder="请选择商品标签" clearable />
        </el-form-item>
        <el-form-item label="商品状态" v-if="showStatus">
          <el-select size="mini" v-model="params.Status" placeholder="请选择商品状态" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item> -->
      </template>
      <template slot="table">
        <el-table-column prop="TradeUnitCode" label="单位编码" min-width="150px" />
        <el-table-column prop="TradeUnitName" label="单位名称" min-width="110px" />
        <!-- <el-table-column label="商品属性" min-width="200px">
          <template slot-scope="{row}">
            <span v-if="row.IsSale">销售、</span>
            <span v-if="row.IsPurchase">采购、</span>
            <span v-if="row.IsSelf">自制、</span>
            <span v-if="row.IsConsume">耗材、</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="TradeUnitType" label="单位类型" width="100px" align="center">
          <template slot-scope="{row}">
            <!-- <el-tag size="mini" v-if="row.CustomerType==3" type="primary">供应商</el-tag> -->
            <el-tag size="mini" v-if="row.CustomerType==0" type="success">批发</el-tag>
            <el-tag size="mini" v-else type="danger">零售</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    typeList: {
      default: () => []
    }
  },
  beforeMount() {
    
    this.params.TradeUnitTypeList = this.typeList
    if(this.typeList.length > 0) {
      this.v1 = this.typeList.indexOf(1) > -1
      this.v2 = this.typeList.indexOf(2) > -1
      this.v3 = this.typeList.indexOf(3) > -1
      console.log("this.v1",this.v1)
      console.log("this.v2",this.v2)
      console.log("this.v3",this.v3)
      if(this.v2 && !this.v1)
      {
        this.params.TradeUnitType = 2;
      }
    }
  },
  data() {
    return {
      api: require("@/api/ba/tradeUnit").default,
      params: {
          TradeUnitType: 1,
          TradeUnitTypeList: [],
          TradeUnitName: "",
          TradeUnitCode: ""
      },
      v1: true,
      v2: true,
      v3: true
    };
  },
  methods: {

    delRange(ids) {
      
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>